/**
 * src/components/admin/AdminUI.jsx
 * 管理画面で共通利用するサブコンポーネント集
 */
import React, { useEffect } from "react";
import "../styles/admin.css";

/* ── フラッシュメッセージ ── */
export function Flash({ message, type, onClose }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className={`adm-flash adm-flash--${type}`}>
      <span>{message}</span>
      <button className="adm-flash__close" onClick={onClose}>✕</button>
    </div>
  );
}

/* ── モーダル ── */
export function Modal({ show, title, size = "md", onClose, children }) {
  if (!show) return null;
  return (
    <div className="adm-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`adm-modal ${size === "sm" ? "adm-modal--sm" : ""}`}>
        <h3 className="adm-modal__title">{title}</h3>
        {children}
      </div>
    </div>
  );
}

/* ── フォームフィールドラベル ── */
export function FormField({ label, required, hint, children }) {
  return (
    <div className="adm-form-field">
      <label className="adm-form-label">
        {label}
        {required && <span className="adm-form-required">*</span>}
      </label>
      {children}
      {hint && <div className="adm-form-hint">{hint}</div>}
    </div>
  );
}

/* ── モーダル操作ボタン行 ── */
export function ModalActions({ onCancel, onConfirm, confirmLabel = "保存", confirmClass = "adm-btn--primary", disabled = false }) {
  return (
    <div className="adm-modal__actions">
      <button className="adm-btn adm-btn--default" onClick={onCancel}>
        キャンセル
      </button>
      <button
        className={`adm-btn ${confirmClass}`}
        onClick={onConfirm}
        disabled={disabled}
      >
        {confirmLabel}
      </button>
    </div>
  );
}

/* ── ページネーション行 ── */
export function Pagination({ current, total, onChange, count }) {
  return (
    <div className="adm-pagination">
      <button
        className="adm-btn adm-btn--default adm-btn--sm"
        onClick={() => onChange(current - 1)}
        disabled={current <= 1}
      >
        ←
      </button>
      <span>{current} / {total}</span>
      <button
        className="adm-btn adm-btn--default adm-btn--sm"
        onClick={() => onChange(current + 1)}
        disabled={current >= total}
      >
        →
      </button>
      {count !== undefined && (
        <span className="adm-pagination__count">{count} 件</span>
      )}
    </div>
  );
}
